const formatPhoneNumber = (phoneNumber, countryCode) => {
  if (!countryCode) {
    return phoneNumber;
  }

  let formattedPhoneNumber = phoneNumber;
  const firstCharacter = phoneNumber.charAt(0);
  const secondCharacter = phoneNumber.charAt(1);

  // available prefixes
  const prefixes = {
    NL: "0031",
    BE: "0032",
    FR: "0033",
  };

  // check if first character is 0
  if (firstCharacter !== "0") {
    return phoneNumber; // return original value
  }

  // check if second character is NOT 0
  if (secondCharacter === "0") {
    return phoneNumber; // return original value
  }

  // get prefix
  const prefix = prefixes[countryCode];
  // if prefix is not found, return original value
  if (!prefix) {
    return phoneNumber;
  }

  // remove first character (which is 0)
  formattedPhoneNumber = formattedPhoneNumber.substring(1);
  // add prefix
  formattedPhoneNumber = prefix + formattedPhoneNumber;

  // return formatted value
  return formattedPhoneNumber;
};

export default formatPhoneNumber;
